// This file is automatically generated. Do not edit manually.

import { CustomerOrderType } from "src/api/generated/erp/db/types/tables/customerOrderType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderTypeApi {
	export async function getAll(): Promise<Array<CustomerOrderType>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/masterData/customerOrderTypes/getAll",
			method: "POST",
			data: {},
		});
		return response as Array<CustomerOrderType>;
	}
}
